import { Slider, Typography, Box } from "@mui/material";
import React from "react";

interface LabeledSliderProps {
  value: number | number[];
  label: string;
  onChange: (event: Event, value: number | number[]) => void;
  min: number;
  max: number;
  step: number;
  ariaLabel?: string;
  "data-testid"?: string;
  width?: string;
  marginRight?: string;
  paddingRight?: string;
  marginLeft?: string;
  sliderMarginleft?: string;
}

export default function LabeledSlider(props: Readonly<LabeledSliderProps>) {
  const {
    value,
    label,
    onChange,
    min,
    max,
    step,
    ariaLabel,
    "data-testid": testId,
    width,
    marginRight,
    marginLeft,
    paddingRight,
    sliderMarginleft
  } = props;

  return (
    <Box
      sx={{
        my: 1,
        width: width ?? "100%",
        marginLeft: marginLeft ?? "auto",
        marginRight: marginRight ?? "0",
        paddingRight: paddingRight ?? "0"
      }}
      data-testid={`${testId}-box`}
    >
      <Typography variant="body2" display="block" gutterBottom>
        {label}
      </Typography>
      <Slider
        data-testid={testId}
        value={value}
        min={min}
        aria-labelledby="discrete-slider-always"
        step={step}
        // accessKey={accessKey}
        valueLabelDisplay="auto"
        max={max}
        marks
        aria-label={ariaLabel}
        onChange={onChange}
        sx={[sliderMarginleft ? { width: "95%", ml: sliderMarginleft } : {}]}
      />
    </Box>
  );
}
